import i18n from "@/vue/localization";

const StudentFormats = {
    formatStudent(student, showMiddleName) {
        let vkUrl = null;

        if (student.vkScreenName) {
            vkUrl = "https://vk.ru/" + student.vkScreenName;
        }

        if (student.vkId) {
            vkUrl = "https://vk.ru/id" + student.vkId;
        }
       
        const values = [student.firstName, student.lastName, student.phoneNumber, student.email, vkUrl, student.telegram];

        if (showMiddleName) {
            values.splice(1, 0, student.middleName);
        }

        return values.filter(v => v !== null && v !== "").join(" ") || i18n.t("common.unknown");
    },

    formatStudentShort(student) {
        let vkUrl = null;

        if (student.vkScreenName) {
            vkUrl = "https://vk.ru/" + student.vkScreenName;
        }

        if (student.vkId) {
            vkUrl = "https://vk.ru/id" + student.vkId;
        }

        let end = student.phoneNumber;

        if (!end) {
            end = vkUrl;
        }

        if (!end) {
            end = student.email;
        }

        const values = [student.firstName, student.lastName, end];
        return values.filter(v => v !== null && v !== "").join(" ") || i18n.t("common.unknown");
    }
};

export default StudentFormats;